module.exports = __webpack_public_path__ + "static/media/PALM-PRINT_thumb.d61f0e94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/fabrics-prints/PALM-PRINT_thumb.jpg
// module id = 164
// module chunks = 0